var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_780_53473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2938 22.7062C14.6845 23.0969 15.3176 23.0969 15.7076 22.7062C16.0976 22.3156 16.0982 21.6825 15.7076 21.2925L11.4126 17L23.0002 17C23.5502 17 24.0002 16.55 24.0002 16C24.0002 15.45 23.5529 15 23.0002 15L11.4126 15L15.7057 10.7069C16.0964 10.3162 16.0964 9.68312 15.7057 9.29312C15.3151 8.90312 14.682 8.9025 14.292 9.29312L8.2919 15.2931C8.10003 15.4875 8.00002 15.7437 8.00002 16C8.00002 16.2562 8.09765 16.5117 8.29303 16.7069L14.2938 22.7062ZM16.0001 32C24.8377 32 32.0002 24.8375 32.0002 16C32.0002 7.1625 24.8377 -6.26171e-07 16.0001 -1.39878e-06C7.16252 -2.17138e-06 -4.74197e-05 7.1625 -4.81923e-05 16C-4.89649e-05 24.8375 7.16252 32 16.0001 32ZM16.0001 2C23.7189 2 30.0002 8.28125 30.0002 16C30.0002 23.7187 23.7189 30 16.0001 30C8.28128 30 1.99997 23.7187 1.99997 16C1.99997 8.28125 8.28128 2 16.0001 2Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_780_53473"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftCircle);
export default __webpack_public_path__ + "static/media/arrow-left-circle.a494519347165cd1949f5a07e91757cb.svg";
export { ForwardRef as ReactComponent };